module.exports = __webpack_public_path__ + "img/1g.08cb9958.svg";